export default "__VITE_ASSET__BTNe860L__"